import { createAction } from '../../../store.model';
import { ActionType } from '../landing.action';
import { ColumnId } from '../model/column-id.model';
import { GridType } from '../model/grid-type.model';

export interface FilterRows {
    grid: GridType;
    columnId: ColumnId;
    value: any;
}

export const filterRows = createAction<ActionType, FilterRows>(
    ActionType.EVAL_LANDING__FILTER_ROWS,
);
